/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Quanto budget libera la revoca di un voucher
 */
export enum RilascioBudgetRevoca {

    NESSUNO = 'NESSUNO',

    SOLO_NON_SPESO = 'SOLO_NON_SPESO',

    IMPORTO_INTERO = 'IMPORTO_INTERO'
}

